var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "duplicateModal",
    attrs: {
      id: "duplicate-client-profile-modal-" + _vm.clientProfileDetails.id,
      "modal-dialog-scrollable": false,
      "loaders-disabled": "",
    },
    on: { shown: _vm.resetData, hidden: _vm.handleHidden, hide: _vm.resetData },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm.isEditingLabel
              ? _c(
                  "span",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c("div", [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "client-profile.actions.updateClientProfileLabel"
                            )
                          ) +
                          "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "simple-button",
                      {
                        attrs: {
                          type: "link",
                          "class-name": "text-danger ml-custom-for-button",
                        },
                        on: { click: _vm.showDeleteModal },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("boards.actions.deleteLabel")) +
                            "\n      "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("delete-component-modal", {
                      ref: "deleteComponentModal",
                      attrs: { message: _vm.modalText },
                      on: { "confirm-delete": _vm.handleDelete },
                    }),
                  ],
                  1
                )
              : _vm.addingLabel && !_vm.isEditingLabel
              ? _c("span", [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("client-profile.actions.addLabel")) +
                      "\n    "
                  ),
                ])
              : _c("span", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.pin
                          ? _vm.$t(
                              "client-profile.actions.confirmCreateNewProfileAndPin"
                            )
                          : _vm.$t(
                              "client-profile.actions.confirmCreateNewProfile"
                            )
                      ) +
                      "\n    "
                  ),
                ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.isEditingLabel || _vm.addingLabel
              ? _c("i18n", {
                  staticClass: "m-0 d-inline",
                  attrs: {
                    path: "client-profile.actions.updateLabelText",
                    tag: "p",
                  },
                })
              : _c("i18n", {
                  staticClass: "m-0 d-inline",
                  attrs: {
                    path: "client-profile.actions.confirmDuplicateProfileText",
                    tag: "p",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "pinText",
                      fn: function () {
                        return [
                          _vm.pin
                            ? _c("i18n", {
                                staticClass: "m-0",
                                attrs: {
                                  path: "client-profile.actions.andPinApplication",
                                  tag: "span",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "applicationId",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "bold text-primary",
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application.applicationID"
                                                    )
                                                  ) +
                                                  ": " +
                                                  _vm._s(_vm.applicationId) +
                                                  "\n            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3504576113
                                ),
                              })
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            !_vm.addingLabel
              ? _c("span", { staticClass: "d-block mb-3" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("client-profile.actions.addLabelToDuplicate")
                      ) +
                      "\n    "
                  ),
                ])
              : _c("span", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("client-profile.actions.addNewLabelToProfile")
                      ) +
                      "\n    "
                  ),
                ]),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "align-items-end" },
              [
                _c(
                  "b-col",
                  [
                    _c("material-input", {
                      attrs: {
                        "class-name": "mb-0",
                        "on-type": "",
                        label: _vm.$t("global.words.label"),
                      },
                      model: {
                        value: _vm.labelText,
                        callback: function ($$v) {
                          _vm.labelText = $$v
                        },
                        expression: "labelText",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-col", [
                  _c(
                    "div",
                    { staticClass: "form-group theme-colorpicker" },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "extra-small text-light-gray text-uppercase",
                        },
                        [_vm._v(_vm._s(_vm.$tc("global.words.color", 1)))]
                      ),
                      _vm._v(" "),
                      _c("colorpicker", {
                        attrs: { color: _vm.labelColor },
                        on: {
                          "update:color": function ($event) {
                            _vm.labelColor = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group-material" }, [
              _c(
                "label",
                { staticClass: "title text-light-gray mb-2 mb-lg-0" },
                [_vm._v(_vm._s(_vm.$t("global.words.preview")))]
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "justify-content-center",
                attrs: { "no-gutters": "" },
              },
              [
                _c(
                  "b-col",
                  { staticClass: "position-relative", attrs: { cols: "6" } },
                  [
                    _c(
                      "profile-card",
                      _vm._b(
                        {},
                        "profile-card",
                        Object.assign({}, _vm.clientProfileDetails, {
                          labelText: _vm.labelText,
                          labelColour: _vm.labelColor,
                          rottingDaysThreshold: 0,
                        }),
                        false
                      )
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "overlay" }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            !_vm.addingLabel
              ? _c(
                  "b-row",
                  {
                    staticClass: "justify-content-start",
                    attrs: { "no-gutters": "" },
                  },
                  [
                    _c(
                      "b-col",
                      { staticClass: "pt-3", attrs: { cols: "3" } },
                      [
                        _c("i18n", {
                          staticClass: "d-inline",
                          attrs: {
                            path: "client-profile.actions.assignToBoard",
                            tag: "p",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "m-2",
                            attrs: {
                              variant: "primary",
                              "toggle-class": _vm.toggleClass,
                              "menu-class": _vm.menuClass,
                              text: _vm.selectedBoard.name,
                              dropleft: _vm.dropLeft,
                            },
                          },
                          _vm._l(_vm.sortedBoards, function (ref) {
                            var name = ref.name
                            var owner = ref.owner
                            var ownerDetails = ref.ownerDetails
                            var isDefault = ref.default
                            var id = ref.id
                            var numberOfClients = ref.numberOfClients
                            return _c(
                              "b-dropdown-item",
                              {
                                key: id,
                                staticClass: "clickable",
                                attrs: {
                                  disabled: _vm.selectedBoard.id === id,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.transferProfile(id, $event)
                                  },
                                },
                              },
                              [
                                isDefault && owner
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-primary px-4 ml-0 mr-1",
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t("global.words.default")
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(name) +
                                      "\n              " +
                                      _vm._s(
                                        _vm.selectedBoard.id === id
                                          ? "- " +
                                              _vm.$t("global.words.selected")
                                          : ""
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("boards.messages.boardOwner")
                                      ) +
                                      ":\n              " +
                                      _vm._s(ownerDetails.givenName) +
                                      "\n              " +
                                      _vm._s(ownerDetails.familyName) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(numberOfClients) +
                                      "\n              " +
                                      _vm._s(
                                        _vm.$tc(
                                          "global.doorr.client",
                                          parseInt(numberOfClients)
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: { loading: _vm.loading, disabled: !_vm.isValid },
                on: { click: _vm.handleConfirmClick },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.isEditingLabel || _vm.addingLabel
                        ? _vm.$t("global.words.save")
                        : _vm.$t("client-profile.actions.createNewProfile")
                    ) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }